
import { getPath } from '@percept/utils'


export default ({ env, ignore = {} }) =>

  () => next => action =>

    !getPath(ignore, [env], []).includes(action && action.type) && next(action)